/**
 * Excel Configurator Adapter Registration
 *
 * Registers all data source adapters with the global registry.
 * Import this file in your app initialization to enable all adapters.
 */

import { registerAdapter } from "@/lib/excel-configurator/core";
import { shipmentDataAdapter } from "./adapters";

/**
 * Register all excel configurator adapters
 */
export function registerExcelAdapters(): void {
  // Register shipment adapter
  registerAdapter(shipmentDataAdapter);

  // Future adapters will be registered here:
  // registerAdapter(orderDataAdapter);
  // registerAdapter(productionDataAdapter);
  // registerAdapter(inventoryDataAdapter);

  console.info("[Excel Configurator] All adapters registered");
}
